import { useState } from "react";
import { useAuth } from "@/contexts/auth-context";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export function AmSettingsPage() {
  const { user } = useAuth();
  const signupLink = user?.signup_link || "";
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    if (!signupLink) return;
    try {
      await navigator.clipboard.writeText(signupLink);
      setCopied(true);
      toast.success("Signup link copied.");
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy the link.");
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">AM Settings</h1>
        <p className="mt-1 text-sm text-gray-600">Settings for your account manager profile.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Signup link</CardTitle>
          <p className="text-sm font-normal text-gray-600">
            Share this link when you post about DealerDog. A dealer who signs up through it is assigned to you, and
            you receive the signup email along with the admins. Add{" "}
            <span className="font-mono text-xs">utm_source</span>,{" "}
            <span className="font-mono text-xs">utm_medium</span>, or{" "}
            <span className="font-mono text-xs">utm_campaign</span> before <span className="font-mono text-xs">#create-account</span>{" "}
            if you want to record where it was posted.
          </p>
        </CardHeader>
        <CardContent className="space-y-3">
          {signupLink ? (
            <div className="flex flex-col gap-2 sm:flex-row">
              <Input readOnly value={signupLink} className="font-mono text-xs" />
              <Button type="button" onClick={copyLink} className="shrink-0">
                {copied ? "Copied" : "Copy link"}
              </Button>
            </div>
          ) : (
            <p className="text-sm text-gray-600">Your signup link is not available yet. Ask a superadmin to open your user in Django admin and save it.</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
